<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-readOffline__readoffline">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
	     <el-form-item>
          <el-input v-model="dataForm.teacherName" placeholder="姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('readOffline:readoffline:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('readOffline:readoffline:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="title" label="标题" header-align="center" align="center"></el-table-column>
        <el-table-column prop="teacherName" label="负责老师" header-align="center" align="center"></el-table-column>

		<el-table-column prop="status" label="状态" header-align="center" align="center">
		<template slot-scope="scope">
		<el-tag v-if="scope.row.status === 0" size="small" type="warning">未开始</el-tag>
		<el-tag v-if="scope.row.status === 1" size="small" type="success">进行中</el-tag>
		<el-tag v-if="scope.row.status === 2" size="small" type="danger">已结束</el-tag>
		</template>
		</el-table-column>

		<el-table-column prop="joinNum" label="签到人数" header-align="center" align="center"></el-table-column>

        <el-table-column prop="addr" label="地址" header-align="center" align="center"></el-table-column>

        <el-table-column prop="startDate" label="开始时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="endDate" label="结束时间" header-align="center" align="center"></el-table-column>
		 <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('readOffline:readoffline:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('readOffline:readoffline:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>

			 <el-button   type="text" size="small" @click="download(scope.row)">签到二维码</el-button>

			<el-button   type="text" size="small" @click="listHandle(scope.row)">签到列表</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>

	    <div id="1" style="display: none">
    <vue-qr :correctLevel="3"
            :logoScale="0.3"
            :text="qrCodeText"
            :size="256"
            :margin="10"
            :dotScale="1"
            colorDark="#303133"
            style="margin: 10px">
    </vue-qr>
    </div>
  <canvas id="box" style="display: none;background: #FFFFFF;" width="270px"
          height="300px"></canvas>

    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './readoffline-add-or-update'
import { addDynamicRoute } from '@/router'
import VueQr from 'vue-qr'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/readOffline/readoffline/page',
        getDataListIsPage: true,
        exportURL: '/readOffline/readoffline/export',
        deleteURL: '/readOffline/readoffline',
        deleteIsBatch: true
      },
	   qrCodeText: '',
      dataForm: {
      }
    }
  },
  watch: {
  },
  methods: {
	  listHandle (row) {
      const routeParams = {
        routeName: `${this.$route.name}__${row.id}`,
        title: '签到列表',
        path: 'readOffline/readofflinestudent',
        params: {
          readOfflineId: row.id
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    },
    download (row) {
      // this.$http.get(`organization/organization/getOrganizationByAppId/${value}`).then(({ data: res }) => {
      //    this.logoSrc = res.data.logoUrl
      this.qrCodeText = row.id
      console.log(this.qrCodeText)
      const that = this
      setTimeout(function () {
        that.printCanvas(1, 'single')
      }, 500)
      //   }).catch((e) => {
      //  return this.$message.error(e.msg)
      //      })
    },
    printCanvas (id, type) { // id表示对应的二维码标签的id   type表示画布的类型
      const c = document.getElementById('box') // 获取canvas画布 画布大小和canvas大小一致
      // let picName = '测试图片' + id
      const ctx = c.getContext('2d')
      c.height = c.height // 清空画布，重新绘制
      const imageData = ctx.getImageData(0, 0, c.width, c.height)
      for (let i = 0; i < imageData.data.length; i += 4) {
        if (imageData.data[i + 3] === 0) {
          imageData.data[i] = 255
          imageData.data[i + 1] = 255
          imageData.data[i + 2] = 255
          imageData.data[i + 3] = 255
        }
      }
      ctx.putImageData(imageData, 0, 0)
      ctx.fillStyle = '#303133'
      let div = null//    设置div变量
      // 判断类型：single 单张  batch  批量
      if (type !== 'single') { //  获取到需要绘制到canvas的div即二维码div
        div = document.getElementById('batch' + id)
      } else { //  获取到需要绘制到canvas的div即二维码div
        div = document.getElementById(id)
      }
      const img = div.getElementsByTagName('img')[0] //  获取二维码
      ctx.drawImage(img, 7, 7, 256, 256) // 参数依次为：绘制图片， 左，上，宽，高
      ctx.font = '20px bold 微软雅黑 ' // 设置字体大小  这里文字的加粗一直无效，至今没搞清楚原因 有能解决的朋友可以私聊
      // 多画几次，让字体加粗  解决文字无法加粗问题
      for (let i = 0; i < 10; i++) {
        ctx.fillText('签到二维码', 76, 285) // 使用偏移量加粗字体
      }
      const dataUrl = c.toDataURL() // 获取返回的base64的信息
      // this.dataUrls.push({ picData: dataUrl, fileName: picName }) // 把数据存进数组里面
      // 如果类型是单张（single）则下载合成好的图片
      if (type === 'single') {
        const link = document.createElement('a')
        link.download = '签到二维码.jpg'
        link.href = dataUrl
        link.click()
      }
    }

  },
  components: {
    AddOrUpdate,
	    VueQr
  }
}
</script>
